import { Image } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledModalHeader = styled.header`
  margin-bottom: 4rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-bottom: 3rem;
  }
`;

export const StyledCompanyLogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: center;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    gap: 4rem;
  }
`;

export const StyledCompanyLogoWrapper = styled(Image).attrs({
  height: '100px',
  width: '100px',
})`
  border-radius: 50%;
  border: 0.2rem solid;
  border-color: ${({ theme }) => theme.colors.border.light};
`;

export const StyledUploadImageSpan = styled.span`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.text.lightest};
`;
